import { css } from "@emotion/react";
import { breakpoints, typography } from "shared";

const container = css`
  display: flex;
  flex-direction: column;
  gap: 20px;
  row-gap: 80px;

  @media ${breakpoints.fromMed} {
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-evenly;
  }
`;

const heading = css`
  ${typography.heading}
  margin-top: 100px;
  margin-bottom: 40px;
  text-align: center;
`;

export default { container, heading };
